import React from 'react'
import { Button } from 'react-bootstrap'

const ActionButton = ({
    onClick = () => {},
    children,
    variant = 'primary'
}) => {
    return (
        <div style={{ padding: '5px', display: 'inline-block'}}>
            <Button
                variant={variant}
                onClick={() => onClick()}
            >
                {children}
            </Button>
        </div>
    )
}

export default ActionButton